import { Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import moment from 'moment';

import { DashboardType } from '../../../../generated/graphql';
import { StandupDashboardServiceService } from '../standup-dashboard-service.service';
import { RelayIdService } from '../../../shared/relay-id.service';
import { FilterInterface } from '../../../shared/filter-bar/filter-bar.component';

@Component({
  selector: 'app-critical-orders-table',
  templateUrl: './critical-orders-table.component.html',
  styleUrls: ['./critical-orders-table.component.scss']
})
export class CriticalOrdersTableComponent implements OnInit {
  isLoading = true;
  dataSource;
  displayedColumns = ['region', 'order', 'company', 'criteria'];
  initDates: FilterInterface;

  @Input() dashboardTitle;
  @Input() card;
  @Input() dashboardItem: DashboardType;

  constructor(
    private dashboardService: StandupDashboardServiceService,
    private relayIdService: RelayIdService
  ) { }

  ngOnInit(): void {
    // Default to this week's data
    this.initDates = {
      dateRange: {
        dateFrom: moment().startOf('isoWeek'),
        dateTo: moment().endOf('isoWeek')
      }
    };

    if (this.card?.id) {
      this.loadCriticalOrders(
        moment().startOf('isoWeek').format('YYYY-MM-DD'),
        moment().endOf('isoWeek').format('YYYY-MM-DD')
      );
    }
  }

  onFilterChanges(filters: FilterInterface): void {
    if (filters.dateRange?.dateFrom && filters.dateRange?.dateTo) {
      const dateFrom = moment(filters.dateRange.dateFrom).format('YYYY-MM-DD');
      const dateTo = moment(filters.dateRange.dateTo).format('YYYY-MM-DD');
      this.loadCriticalOrders(dateFrom, dateTo);
    }
  }

  private loadCriticalOrders(dateFrom: string, dateTo: string): void {
    if (!this.card?.id) {
      return;
    }

    this.isLoading = true;

    // If card.allDashboards is true, don't send dashboardId (get all), otherwise send current dashboard ID
    const dashboardId = this.card?.allDashboards ? undefined : this.dashboardItem?.id;
    this.dashboardService.getMetricTableValues(this.card.id, dashboardId, dateFrom, dateTo).pipe(take(1)).subscribe((metricGroups) => {
      const result = [];
      metricGroups.forEach((item: any) => {
        item.metricGroup.metricvalueSet?.edges.forEach(v => {
          const orderId = this.relayIdService.parseId(v?.node?.order?.id);
          const orderTitle = v?.node?.order?.specification?.positionTitle;
          result.push({
            company: v?.node?.client?.name,
            order: orderTitle ? `${orderTitle} (${orderId})` : orderId,
            comments: v?.node?.metricvaluecommentSet?.edges?.map(val => val.node.comment),
            region: v?.node?.regionGroup?.title
          });
        });
      });
      this.dataSource = result;
      this.isLoading = false;
    }, e => this.isLoading = false);
  }
}
